import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes.jsx";
import Navbar from "./components/Navbar.jsx";
import { getCurrentUser } from "./utils/auth.js";
import { jwtDecode } from "jwt-decode";
import { useState, useEffect } from "react";
import { Modal, Box, Typography } from "@mui/material";
import RotateIcon from "@mui/icons-material/ScreenRotation";
import "../src/styles/global.css/global.css";
import { startSignalR } from "./ws/signalRService.js";

export default function App() {
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeLog, setActiveLog] = useState(null);

  const [isLandscape, setIsLandscape] = useState(
    window.innerWidth > window.innerHeight
  );
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    setUser(getCurrentUser());
    startSignalR();

    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      const isTouch = window.matchMedia("(pointer: coarse)").matches;

      setIsTouchDevice(isTouch);
      setIsLandscape(width > height);
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);

  
    const checkTokenExpiration = () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decoded.exp < currentTime) {
          localStorage.removeItem("token");
          setUser(null);
          window.location.href = "/";
        }
      } catch (error) {
        localStorage.removeItem("token");
        setUser(null);
        window.location.href = "/";
      }
    };

    const tokenCheckInterval = setInterval(checkTokenExpiration, 10000); 

    return () => {
      window.removeEventListener("resize", checkDevice);
      clearInterval(tokenCheckInterval);
    };
  }, []);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
 
  const shouldBlock = isTouchDevice && !isLandscape;

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Router>
        {user && <Navbar role={user.role} open={sidebarOpen} />}
        <AppRoutes
          setUser={setUser}
          sidebarOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
          activeLog={activeLog}
          setActiveLog={setActiveLog}
          user={user}
        />
      </Router>

      <Modal
        open={shouldBlock}
        sx={{
          zIndex: 99999,
          transition: "opacity 0.3s ease-in-out",
        }}
      >
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "#000000",
            color: "#ffffff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            p: 3,
          }}
        >
          <RotateIcon
            sx={{
              animation: "spin 2s linear infinite",
              fontSize: "6rem",
              mb: 2,
              color: "#fff",
            }}
          />
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            Zəhmət olmasa cihazı yan çevirin
          </Typography>
          <Typography variant="h6" sx={{ mt: 1, opacity: 0.8 }}>
            Sistemin düzgün görünməsi üçün landscape moduna keçin.
          </Typography>
        </Box>
      </Modal>

      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}
